import RegularInfBox from  "../../Molecules/RegularInfBox/RegularInfBox";
import FS_ABOUT_QUIENESSOMOS_IMAGEN_VIDEO from "../../../assets/img/FS-ABOUT-QUIENESSOMOS-IMAGEN-VIDEO.png";
import "./AboutWhoWeAreSection.scss";
import content from "../../Pages/About/content"
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

const AboutWhoWeAreSection = () => {
	const {language} = useLanguageCtx();

  return (
		<div className="max-width flex wrap space-between top-space-section about aboutWhoWeAreSection-container">
			<img
				src={FS_ABOUT_QUIENESSOMOS_IMAGEN_VIDEO}
				alt="Phone"
				className="aboutWhoWeAre-image img-radius"
			/>
			<div className="aboutWhoWeAre-content-container">
				<RegularInfBox
					yellowTitle={content[language].quienesSomosYellowTitle}
					boldTitle={content[language].quienesSomosBoldText}
					content={content[language].quienesSomosText}
				/>
			</div>
		</div>
	);
}

export default AboutWhoWeAreSection

